var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":_vm.state.color}},[_c('v-toolbar-title',[_vm._v("Email Verification")])],1),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.state.message)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }